export default theme => ({
	menuButton: {
		marginRight: theme.spacing(3)
	},
	hide: {
		display: 'none'
	}
});
